"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.list.title': 'Domande',
    'question.list.empty': 'Nessuna domanda trovata',
};
